<h1 mat-dialog-title >{{data?.camera || 'Photo'}}</h1>
<div mat-dialog-content>

  <img style="max-height: 450px; display: block; margin-left: auto; margin-right: auto;" [src]="data.img | safeHtml"> 

</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>CLOSE</button>
</div>